import { authHeader } from '@/services/auth'
import axios from 'axios'
import { formatCodenamesCall } from '@/services/posts'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

const baseURL = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL + '/social-management-posts'

export default {
  namespaced: true,
  state: {
    socialPostsAnnonces: {
      total: -1,
      list: []
    },
    filters: {
      page: 1,
      limit: 10,
      search: '',
      network: null,
      dateDiff: {
        before: null,
        after: null
      }
    },
    loadingStatus: false,
    modalDelete: false,
    postToDelete: []
  },
  getters: {
    getSocialPostsAnnonces: (state) => state.socialPostsAnnonces,
    getPage: (state) => state.filters.page,
    getLimit: (state) => state.filters.limit,
    getLoadingStatus: (state) => state.loadingStatus,
    getNetwork: (state) => state.filters.network,
    getSearch: (state) => state.filters.search,
    getModalDelete: (state) => state.modalDelete,
    getPostToDelete: (state) => state.postToDelete
  },
  mutations: {
    setSocialPostsAnnonces (state, payload) {
      state.socialPostsAnnonces = payload
    },
    setPage (state, payload) {
      state.filters.page = payload
    },
    setLimit (state, payload) {
      state.filters.limit = payload
    },
    setLoadingStatus (state, payload) {
      state.loadingStatus = payload
    },
    setSearch (state, payload) {
      state.filters.search = payload
    },
    setDateDiff (state, dateDiff) {
      state.filters.dateDiff = dateDiff
    },
    setModalDelete (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    setPostToDelete (state, postToDelete) {
      state.postToDelete = postToDelete
    },
    checkDiffusionsPostsToDelete (state) {
      const posts = []
      state.postToDelete.forEach(function (post) {
        let cpt = 0
        post.diffusions.forEach(function (diffusion) {
          if (diffusion.firstSentAt) {
            cpt = cpt + 1
          }
        })
        if (cpt === 0) {
          posts.push(post)
        }
      })
      state.postToDelete = posts
    },
    setNetwork (state, payload) {
      if (payload === 'allPosts') {
        state.filters.network = null
      } else {
        state.filters.network = payload
      }
    }
  },
  actions: {
    loadSocialPostsAnnonces ({ commit, getters }) {
      commit('setLoadingStatus', true)
      const params = {
        headers: authHeader()
      }
      let url = `${baseURL}`
      const codenamesCall = formatCodenamesCall(false, true)

      // Bug: https://redmine.ubiflow.net/issues/111709
      if (codenamesCall === undefined || codenamesCall.length === 0) {
        commit('setLoadingStatus', false)
        return { total: 0, list: [] }
      }

      let codenames = codenamesCall[0]
      if (getters.getNetwork != null) {
        codenames = getters.getNetwork
      }
      url = url + '?portalCodesAnnonces=' + codenames
      codenamesCall[1].forEach(function (element) {
        url = url + '&linkedPortals[]=' + element
      })
      if (getters.getNetwork != null) {
        url = url + '&annoncesDiffusees=O'
      }
      url = url + '&champsRechercheLibre[]=ville&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference'
      url = url + '&rechercheLibre=' + getters.getSearch
      url = url + '&page=' + getters.getPage
      url = url + '&etat=A'
      url = url + '&perPage=' + getters.getLimit

      // Filters => voir pour ajouter les filtres en fonction des datas envoyé
      return axios.get(url, params)
        .then(response => {
          if (response.data.annonces) {
            const objResponse = {
              total: response.data.total,
              list: response.data.annonces
            }
            commit('setSocialPostsAnnonces', objResponse)
            commit('setLoadingStatus', false)
          }
        }).catch(error => {
          console.log({ type: 'error', message: error })
          commit('setLoadingStatus', false)
        })
    },
    deletePostAnnonce (context) {
      context.commit('setLoadingStatus', true)
      const posts = context.getters.getPostToDelete
      const params = {
        data: posts
      }
      const url = '/annonce'
      const deletePost = HTTP_HYPER_ESPACE_BACKEND
        .delete(url, params)
        .then(response => {
          return { type: 'success', message: 'OK' }
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(function () {
          context.dispatch('loadSocialPostsAnnonces')
          context.commit('setLoadingStatus', false)
          context.commit('setModalDelete', false)
        })
    }
  }
}
